import React, { useCallback } from 'react';
import { Container, Col, Row, Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import './StateButtonPage.css';

// All 50 states data
const STATES_DATA = [
  { name: "Alabama", flag: "/alabamaFlag.png", path: "/us/alabama" },
  { name: "Alaska", flag: "/alaskaFlag.png", path: "/us/alaska" },
  { name: "Arizona", flag: "/arizonaFlag.png", path: "/us/arizona" },
  { name: "Arkansas", flag: "/arkansasFlag.png", path: "/us/arkansas" },
  { name: "California", flag: "/californiaFlag.png", path: "/us/california" },
  { name: "Colorado", flag: "/coloradoFlag.png", path: "/us/colorado" },
  { name: "Connecticut", flag: "/connecticutFlag.png", path: "/us/connecticut" },
  { name: "Delaware", flag: "/delawareFlag.png", path: "/us/delaware" },
  { name: "Florida", flag: "/floridaFlag.png", path: "/us/florida" },
  { name: "Georgia", flag: "/georgiaFlag.png", path: "/us/georgia" },
  { name: "Hawaii", flag: "/hawaiiFlag.png", path: "/us/hawaii" },
  { name: "Idaho", flag: "/idahoFlag.png", path: "/us/idaho" },
  { name: "Illinois", flag: "/illinoisFlag.png", path: "/us/illinois" },
  { name: "Indiana", flag: "/indianaFlag.png", path: "/us/indiana" },
  { name: "Iowa", flag: "/iowaFlag.png", path: "/us/iowa" },
  { name: "Kansas", flag: "/kansasFlag.png", path: "/us/kansas" },
  { name: "Kentucky", flag: "/kentuckyFlag.png", path: "/us/kentucky" },
  { name: "Louisiana", flag: "/louisianaFlag.png", path: "/us/louisiana" },
  { name: "Maine", flag: "/maineFlag.png", path: "/us/maine" },
  { name: "Maryland", flag: "/marylandFlag.png", path: "/us/maryland" },
  { name: "Massachusetts", flag: "/massachusettsFlag.png", path: "/us/massachusetts" },
  { name: "Michigan", flag: "/michiganFlag.png", path: "/us/michigan" },
  { name: "Minnesota", flag: "/minnesotaFlag.png", path: "/us/minnesota" },
  { name: "Mississippi", flag: "/mississippiFlag.png", path: "/us/mississippi" },
  { name: "Missouri", flag: "/missouriFlag.png", path: "/us/missouri" },
  { name: "Montana", flag: "/montanaFlag.png", path: "/us/montana" },
  { name: "Nebraska", flag: "/nebraskaFlag.png", path: "/us/nebraska" },
  { name: "Nevada", flag: "/nevadaFlag.png", path: "/us/nevada" },
  { name: "New Hampshire", flag: "/newHampshireFlag.png", path: "/us/newhampshire" },
  { name: "New Jersey", flag: "/newJerseyFlag.png", path: "/us/newjersey" },
  { name: "New Mexico", flag: "/newMexicoFlag.png", path: "/us/newmexico" },
  { name: "New York", flag: "/newYorkFlag.png", path: "/us/newyork" },
  { name: "North Carolina", flag: "/northCarolinaFlag.png", path: "/us/northcarolina" },
  { name: "North Dakota", flag: "/northDakotaFlag.png", path: "/us/northdakota" },
  { name: "Ohio", flag: "/ohioFlag.png", path: "/us/ohio" },
  { name: "Oklahoma", flag: "/oklahomaFlag.png", path: "/us/oklahoma" },
  { name: "Oregon", flag: "/oregonFlag.png", path: "/us/oregon" },
  { name: "Pennsylvania", flag: "/pennsylvaniaFlag.png", path: "/us/pennsylvania" },
  { name: "Rhode Island", flag: "/rhodeIslandFlag.png", path: "/us/rhodeisland" },
  { name: "South Carolina", flag: "/southCarolinaFlag.png", path: "/us/southcarolina" },
  { name: "South Dakota", flag: "/southDakotaFlag.png", path: "/us/southdakota" },
  { name: "Tennessee", flag: "/tennesseeFlag.png", path: "/us/tennessee" },
  { name: "Texas", flag: "/texasFlag.png", path: "/us/texas" },
  { name: "Utah", flag: "/utahFlag.png", path: "/us/utah" },
  { name: "Vermont", flag: "/vermontFlag.png", path: "/us/vermont" },
  { name: "Virginia", flag: "/virginiaFlag.png", path: "/us/virginia" },
  { name: "Washington", flag: "/washingtonFlag.png", path: "/us/washington" },
  { name: "West Virginia", flag: "/westVirginiaFlag.png", path: "/us/westvirginia" },
  { name: "Wisconsin", flag: "/wisconsinFlag.png", path: "/us/wisconsin" },
  { name: "Wyoming", flag: "/wyomingFlag.png", path: "/us/wyoming" }
];

const StateButtonPage = ({ onStateSelect }) => {
  const handleHapticsClick = useCallback(async (callback) => {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      // console.log('Haptics not available');
    }
    callback();
    // Close the modal when a state is selected
    if (onStateSelect) {
      onStateSelect();
    }
    window.scrollTo(0, 0);
  }, [onStateSelect]);

  const StateButton = useCallback(({ state }) => (
    <Link 
      id='pageLinkState' 
      onClick={() => handleHapticsClick(() => {})} 
      to={state.path}
    >
      <Button size='sm' id='statesModalButtons'>
        <Image id='stateFlagMobile' src={state.flag} alt={`${state.name} Flag`} />
        {state.name}
      </Button>
    </Link>
  ), [handleHapticsClick]);

  // Group states into rows of 3
  const stateRows = [];
  for (let i = 0; i < STATES_DATA.length; i += 3) {
    stateRows.push(STATES_DATA.slice(i, i + 3));
  }

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div id='homebg' className="state-button-page-root" style={containerStyle}>
      <Container>
        {stateRows.map((row, rowIndex) => (
          <Row key={rowIndex}>
            {row.map(state => (
              <StateButton key={state.name} state={state} />
            ))}
          </Row>
        ))}
      </Container>
    </div>
  );
};

export default StateButtonPage;